import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ContentFormatter } from "discover.medical.react-component-library";
import { startFreeTrial } from "../../../reducers/freeTrial/actions";
import ThankYouContainer from "./../../ThankYouContainer";
import Spinner from "../../Spinner";
export class FreeTrialCheckout extends Component {
  componentDidMount() {
    this.props.startFreeTrial();
  }
  render() {
    const { status, errorMessage } = this.props;
    switch (status) {
      case "error":
        return <ContentFormatter>{errorMessage}</ContentFormatter>;
      case "success":
        return <ThankYouContainer isFreeTrial={true} />;
      default:
        return <Spinner className="my-3" />;
    }
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      startFreeTrial,
    },
    dispatch,
  );

export const mapStateToProps = ({ freeTrial }) => ({
  status: freeTrial.status,
  errorMessage: freeTrial.errorMessage,
});

export default connect(mapStateToProps, mapDispatchToProps)(FreeTrialCheckout);
